import { netAmount } from '@/types/MultiPayoutTypes';
import { parseBankAccount } from '@/utils/bankAccountParser';
function pad(value, length, char = ' ') {
    return (value + char.repeat(length)).slice(0, length);
}
function padLeft(value, length, char = '0') {
    return (char.repeat(length) + value).slice(-length);
}
function formatDate(date) {
    const dd = padLeft(String(date.getDate()), 2);
    const mm = padLeft(String(date.getMonth() + 1), 2);
    const yy = padLeft(String(date.getFullYear() % 100), 2);
    return dd + mm + yy;
}
function sanitizeName(name) {
    return name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .replace(/[^A-Z0-9 ]/g, '');
}
export function generateAbo(rows, senderAccount, senderName) {
    const sender = parseBankAccount(senderAccount);
    if (!sender) {
        throw new Error('Neplatné číslo účtu odesílatele');
    }
    const now = new Date();
    const date = formatDate(now);
    // Pre-filter: collect valid items and compute total
    const validItems = [];
    let totalAmountHalere = 0;
    for (const row of rows) {
        const amountHalere = Math.round(netAmount(row) * 100);
        if (amountHalere <= 0)
            continue;
        const recipient = parseBankAccount(row.bankAccount);
        if (!recipient)
            continue;
        totalAmountHalere += amountHalere;
        validItems.push({ recipient, amountHalere });
    }
    const lines = [];
    // UHL1 - file header
    const uhl1 = 'UHL1'
        + date
        + pad(sanitizeName(senderName), 20)
        + '0000000000' // client number
        + '001' // interval start
        + '999' // interval end
        + '000000' // code
        + '000000'; // secret
    lines.push(uhl1);
    // Type 1 - group header
    lines.push(`1 1501 001000 ${padLeft(sender.bankCode, 4)}`);
    // Type 2 - sender account + total
    lines.push(`2 ${sender.prefix}-${sender.account} ${padLeft(String(totalAmountHalere), 12)} ${date}`);
    // Item records
    for (const item of validItems) {
        const r = item.recipient;
        lines.push(`${r.prefix}-${r.account} ${padLeft(String(item.amountHalere), 12)} ${padLeft('0', 10)} ${padLeft(r.bankCode, 4)}${padLeft('0', 4)} ${padLeft('0', 10)}`);
    }
    // Type 3 - group close
    lines.push('3 +');
    // Type 5 - file close
    lines.push('5 +');
    return lines.join('\r\n') + '\r\n';
}
export function downloadAbo(content, filename) {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}
